import {Types as LoanApplicationsListDataTypes} from '../loanApplicationsList/data';
import * as MainMenuActions from '../../../actions/MainMenuActions';
import {createSelector} from 'reselect';
import {State} from '../../../types/mx/reducers';
import {Doc} from '../../types/reducers';
import {DocumentTypes} from '../../../loan/common/types/types';

export const Types = {
    CHATS_GO_TO_LOAN_APP_CHAT: 'CHATS_GO_TO_LOAN_APP_CHAT',
    CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT:
        'CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT',
    CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_SUCCESS:
        'CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_SUCCESS',
    CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_STOP:
        'CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_STOP',
    CHATS_ON_SEND_MESSAGE_TO_CHAT: 'CHATS_ON_SEND_MESSAGE_TO_CHAT',
    UPDATE_CHAT_INFO: 'UPDATE_CHAT_INFO',
    UPDATE_CHAT_INFO_SUCCESS: 'UPDATE_CHAT_INFO_SUCCESS',
    UPDATE_CHAT_PIN: 'UPDATE_CHAT_PIN',
    CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_DOCS:
        'CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_DOCS',
    CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_DOCS_SUCCESS:
        'CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_DOCS_SUCCESS',
    UPLOAD_LOAN_ATTACHMENT: 'UPLOAD_LOAN_ATTACHMENT',
    ON_UPLOAD_LOAN_ATTACHMENT_SUCCESS: 'ON_UPLOAD_LOAN_ATTACHMENT_SUCCESS',
    ON_FIREBASE_DOCUMENT_UPDATED_SUCCESS:
        'ON_FIREBASE_DOCUMENT_UPDATED_SUCCESS',
    UPLOAD_CHAT_DOCUMENT: 'UPLOAD_CHAT_DOCUMENT',
    DELETE_CHAT_DOCUMENT: 'DELETE_CHAT_DOCUMENT',
    ON_DELETE_DOCUMENT_FROM_LOAN_APPLICATION_ATTACHMENTS:
        'ON_DELETE_DOCUMENT_FROM_LOAN_APPLICATION_ATTACHMENTS',
};

export const INITIAL_STATE = {
    loanApplication: null,
    messages: [],
    docs: {
        byId: {},
    },
    lastPage: 1,
};

const data = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case Types.CHATS_GO_TO_LOAN_APP_CHAT:
            return {
                ...state,
                loanApplication: action.payload,
                lastPage: 1,
            };
        case Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_SUCCESS:
            return {
                ...state,
                messages: action.payload.messages,
                lastPage: action.payload.lastPage + 1,
            };
        case Types.UPDATE_CHAT_INFO_SUCCESS:
            return {
                ...state,
                loanApplication: {
                    ...state.loanApplication,
                    chat: action.payload,
                },
            };
        case Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_DOCS_SUCCESS: {
            const docsById = action.payload.reduce((map, item) => {
                map[item.id] = {
                    ...item,
                };
                return map;
            }, {});
            return {
                ...state,
                docs: {
                    byId: docsById,
                },
            };
        }
        case Types.ON_FIREBASE_DOCUMENT_UPDATED_SUCCESS: {
            return {
                ...state,
                docs: {
                    byId: {
                        ...state.docs.byId,
                        [action.payload.docId]: {
                            ...state.docs.byId[action.payload.docId],
                            assigned: action.payload.assigned,
                        },
                    },
                },
            };
        }
        case LoanApplicationsListDataTypes.CHATS_GO_TO_GROUPED_LIST:
        case MainMenuActions.ON_CLICK_MAIN_MENU_ITEM.name:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default data;

export const Creators = {
    chatsGoToLoanAppChat: (item) => ({
        type: Types.CHATS_GO_TO_LOAN_APP_CHAT,
        payload: item,
    }),
    chatsOnLoadLoanApplicationsChat: (lastPage) => ({
        type: Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT,
        payload: lastPage,
    }),
    chatsOnLoadLoanApplicationsChatSuccess: (
        messages,
        lastPage,
        hasMoreMessages = true,
    ) => ({
        type: Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_SUCCESS,
        payload: {messages, lastPage, hasMoreMessages},
    }),
    chatsOnLoadLoanApplicationsChatStop: () => ({
        type: Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_STOP,
    }),
    chatsOnSendMessageToChat: (
        message,
        isSystem = false,
        isDocument = false,
    ) => ({
        type: Types.CHATS_ON_SEND_MESSAGE_TO_CHAT,
        payload: {message, isSystem, isDocument},
    }),
    updateChatInfo: (
        loanApplicationHash,
        pinned = null,
        reason = null,
        message = null,
    ) => ({
        type: Types.UPDATE_CHAT_INFO,
        payload: {loanApplicationHash, pinned, reason, message},
    }),
    updateChatInfoSuccess: (chat) => ({
        type: Types.UPDATE_CHAT_INFO_SUCCESS,
        payload: chat,
    }),
    updateChatPin: (pinned = null, reason = null) => ({
        type: Types.UPDATE_CHAT_PIN,
        payload: {pinned, reason},
    }),
    chatsOnLoadLoanApplicationsChatDocs: () => ({
        type: Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_DOCS,
    }),
    chatsOnLoadLoanApplicationsChatDocsSuccess: (docs) => ({
        type: Types.CHATS_ON_LOAD_LOAN_APPLICATIONS_CHAT_DOCS_SUCCESS,
        payload: docs,
    }),
    uploadDocument: (doc: Doc, documentType: DocumentTypes) => ({
        type: Types.UPLOAD_LOAN_ATTACHMENT,
        payload: {doc, documentType},
    }),
    onUploadDocumentSuccess: (docId: string, documentType: DocumentTypes) => ({
        type: Types.ON_UPLOAD_LOAN_ATTACHMENT_SUCCESS,
        payload: {docId, documentType},
    }),
    onFirebaseDocumentUpdatedSuccess: (
        docId,
        assigned: Partial<DocumentTypes>,
    ) => ({
        type: Types.ON_FIREBASE_DOCUMENT_UPDATED_SUCCESS,
        payload: {docId, assigned},
    }),
    uploadChatDocument: (file) => ({
        type: Types.UPLOAD_CHAT_DOCUMENT,
        payload: file,
    }),
    deleteChatDocument: (messageId, url) => ({
        type: Types.DELETE_CHAT_DOCUMENT,
        payload: {messageId, url},
    }),
    onDeleteDocumentFromLoanApplicationAttachments: (documentId) => ({
        type: Types.ON_DELETE_DOCUMENT_FROM_LOAN_APPLICATION_ATTACHMENTS,
        payload: documentId,
    }),
};

export const Selectors = {
    docsList: createSelector(
        (state: State) => state.chats.chat.data.docs.byId,
        (docs) =>
            Object.keys(docs).map((i) => ({
                ...docs[i],
            })),
    ),
};
